export enum StorageType {
    localStorage = 0,
    sessionStorage = 1
}

export class AuthConfig {
    public storageType: StorageType = StorageType.localStorage;
    public storageName = 'oauthToken';
    public baseUrl: string;
    public clientId: string;
    public scope: string;
    public redirectUri: string;
    public profileUri: string;
    public logoutPath: string;
}
export const authConfig: AuthConfig = {
    storageType: StorageType.localStorage,
    storageName: 'oauthToken',
    baseUrl: '',
    clientId: 'VBL.Manage.End',
    scope: 'openid profile default-api',
    redirectUri: window.top.location.origin,
    profileUri: 'userinfo',
    logoutPath: '/'
};

export function getStorage() {
    let storage: Storage;
    if (authConfig.storageType === StorageType.localStorage) {
        storage = localStorage;
    } else {
        storage = sessionStorage;
    }
    return storage;
}

export function getToken(): any {
    const dataString = getStorage()[authConfig.storageName];
    if (dataString) {
        const data = JSON.parse(dataString);
        if (data && data.expires_at && new Date(data.expires_at) >= new Date()) {
            return data;
        }
    }
    return null;
}

export function getAuthorizationHeader(): string {
    const token = getToken();
    if (token) {
        const tokenType = token.token_type;
        const accessToken = token.access_token;
        // todo:ä¸´æ¶åæ¶å¤§å
        // return `${tokenType[0].toUpperCase() + tokenType.substr(1)} ${accessToken}`;
        return `${tokenType[0] + tokenType.substr(1)} ${accessToken}`;
    }
    return '';
}

export function setToken(data: any) {
    getStorage()[authConfig.storageName] = JSON.stringify(data);
}

export function removeToken() {
    delete getStorage()[authConfig.storageName];
}


export function logout() {
    sessionStorage.clear();
    removeToken();
    window.top.location.href = `${authConfig.logoutPath}`;
}

export function getAuthorizationHeaderByUrl(url: string): string {
    return getAuthorizationHeader();
}

export class RightsCheckModel {
    constructor(data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = !!getToken().menuList.some(x => x === data[key].toString());
            }
        }
    }
}

export class MenuModel {
    public key?: number;
    public title: string;
    public routerLink?: string;
    public icon?: string;
    public privilege?: number;
    public children?: MenuModel[];
    public open?: boolean;
    public selected?: boolean;
    public authCode?: number;
}

export const menuCheck = (menuList: MenuModel[], type: string): any => {
    if (!!!getToken().menuList) {
        logout();
    }
    const res: MenuModel[] = [];
    const linkLink: string[] = ['/home', '/'];
    menuList.map(y => {
        if (y.children) {
            y.children = y.children.filter(z => {
                if (z.authCode) {
                    return !!getToken().menuList.some(x => x === z.authCode.toString());
                } else {
                    return false;
                }
            });
            if (y.children) {
                if (y.children.length) {
                    y.children.map(x => linkLink.push(x.routerLink));
                    res.push(y);
                }
            }
        } else {
            if (y.authCode) {
                if (getToken().menuList.some(x => x === y.authCode.toString())) {
                    res.push(y);
                    linkLink.push(y.routerLink);
                }
            }
        }
    });
    return type === 'menu' ? res : linkLink;
};

